import { useMemo } from 'react';
import { prop } from 'ramda';
import { useAppSelector } from '@core/js/store/hooks';

import { SHOWING_MODE } from './../constants';

export const useShowingMode = () => {
    const {
        enableCookiesAdmission,
        enablePresistentCookieLayer
    } = useAppSelector(prop('cookiesConfiguration'));

    return useMemo(() => {
        if (!enableCookiesAdmission) {
            return SHOWING_MODE.HIDDEN;
        } else if (!enablePresistentCookieLayer) {
            return SHOWING_MODE.COMMON;
        }

        return SHOWING_MODE.PERSISTENT;
    }, [enableCookiesAdmission, enablePresistentCookieLayer]);
};
